// import Swiper core, modules, and css
import Swiper from 'swiper';
// import { Pagination, Autoplay, Navigation } from 'swiper/modules'; // import Swiper modules (if needed). Full list here: https://swiperjs.com/swiper-api#modules

import './index.scss'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import { SplitText } from "./../../js/SplitText";

import { ElementExplorer } from "./../../js/ElementExplorer";

import { Expandable } from "./../../js/Expandable";


import { toggleSwiperLock } from './../../js/toggleSwiperLock'

const vh = (coef) => window.innerHeight * (coef/100);

class TTSHub {
    constructor(el) {
        this.console = {
          log: (smth) => console.log(`%c${smth}`, 'color:aqua')
        }
        // this.console.log('TTSHub::constructor')
        
        this.$el = el
        
        
    }
    initElementExplorer() {
        this.currentChapterId = 'idle'
        this.elementExplorer = new ElementExplorer()
    }
    initSwiper() {
        this.swiper = new Swiper(this.$el.querySelector('.swiper'), {
            slidesPerView: 'auto',
            spaceBetween: 35,
            speed: 1000,
            watchOverflow: true,
            centeredSlides: true,
            // allowTouchMove: true,
            focusableElements: 'input, select, option, textarea, video, label', // I removed 'button' from the list
            // slideToClickedSlide: true,
            effect: 'slide',
            on: {
                init: function (swiper) {
                    if (swiper.isLocked) swiper.el.classList.add('locked')
                },
                click: function (swiper) {
                    // console.log(`%cacf-tts-hub::swiper::click ${this.clickedIndex}`, 'color:aqua')
                    swiper.slideTo(this.clickedIndex, 1000)  
                //     /*const downwards = parseInt(e.target.dataset.i) > this.currentIndex
                //     !this.animating && this.goto(parseInt(e.target.dataset.i), downwards)*/
                },
                resize: function( swiper ) {
                  return toggleSwiperLock(swiper)
                },
            },
        })
    }
    init() {
        // this.console.log('TTSHub::init')
        
        
        this.unblurKVImage()
        
        // this.fetchHDImage()
        
        this.initElementExplorer()
        
        this.initIntro()
        
        // this.initScrollToScreensContainer()
        
        this.initNavigation()
        
        this.initAudio()
        
        this.initChapters()
    }
    // async fetchHDImage() {
    //     console.log(hd_kv_panoramique_rvb.default)
        
    //     /* global fetch */
    //     const response = await fetch(hd_kv_panoramique_rvb.default)
    //     // if (response.status !== 200) return
    //     // console.log('fetched', response)
        
    //     // // else
    //     // const blob = await response.blob()
    //     // console.log('blobbed', blob)
    //     // const img = document.querySelector('[data-explore-me] > img')
    //     // const objectURL = URL.createObjectURL(blob)
    //     // img.onload = () => URL.revokeObjectURL(img.src)
    //     // img.src = objectURL
    //     // img.style.filter = 'none'
    //     // console.log('HD KV fetched & set!')
    
    //     /* another attempt */    
    //     const img = document.querySelector('[data-explore-me] > img')
    //     img.onload = () => {
    //         console.log('load event')
    //         img.style.filter = 'none'   
    //     }
    //     img.src = response.url
    // }
    unblurKVImage() {
        const img = document.querySelector('[data-explore-me] > img')
        if(img.complete && img.naturalWidth > 0){
            // this.console.log('Image Loaded Sucessfully')
            img.style.filter = 'none'
        } else {
            img.addEventListener('load', () => {
                // this.console.log('Image Loaded Sucessfully')
                img.style.filter = 'none'
            }, {capture: false, passive: true, once: true} || false)
        }
    }
    initNavigation() {
        this.initSwiper()
        this.initExpandables()
    }
    initChapters() {
        this.chapterTransitionDuration = 2 // in seconds
        this.chapters = [...document.querySelectorAll('[data-chapter]')]
        
        this.chapters.forEach(_$chapter => {
            const $title = _$chapter.querySelector('.acf-tts-hub__section-title')
            $title.splitText = new SplitText($title, { 
                splitChars: true, 
            })
        })
    }
    set chapterAnimOngoing(bool) {
        this._chapterAnimOngoing = bool
        this.$el.dataset.animOngoing = bool
    }
    get chapterAnimOngoing() {
        return this._chapterAnimOngoing
    }
    revealChapter(chapterId, downwards = true) {
        // this.console.log(`::revealChapter(${chapterId})`)
        // this.steps[i].dataset.active = true
        
        const $chapter = this.$el.querySelector(`#${chapterId}`)
        const $chapterTitle = $chapter.querySelector('.acf-tts-hub__section-title')
        
        this.chapterAnimOngoing = true
        
        const appear = gsap.fromTo($chapterTitle.splitText.chars, {
            yPercent: downwards ? 100 : -100,
            opacity: 0,
        }, {
            yPercent: 0,
            stagger: 0.05,
            ease: "power2",
            delay: this.chapterTransitionDuration / 2,
            duration: this.chapterTransitionDuration / 2 * 0.6,
            opacity: 1,
        })
        
        gsap.fromTo($chapter.querySelectorAll('[data-chapter-content]'), {
            opacity: 0,
        }, {
            opacity: 1,
            ease: 'power2.in',
            delay: this.chapterTransitionDuration / 2,
            duration: this.chapterTransitionDuration / 2 * 0.3,
            delay: this.chapterTransitionDuration * 0.7,
            onComplete: () => {
                this.chapterAnimOngoing = false
            }
        })
        
        this.elementExplorer.focusNamedPoint(chapterId)
    }
    hideChapter(chapterId, downwards = true) {
        // this.console.log(`::hideChapter(${chapterId})`)
        if (chapterId === 'idle') return
        
        // else
        this.chapterAnimOngoing = true
        const $chapter = this.$el.querySelector(`#${chapterId}`)
        const $chapterTitle = $chapter.querySelector('.acf-tts-hub__section-title')
        
        const disappear = gsap.fromTo($chapterTitle.splitText?.chars, {
            yPercent: 0,
            opacity: 1
        }, {
            yPercent: downwards ? -100 : 100,
            stagger: 0.05,
            ease: "power2",
            duration: this.chapterTransitionDuration / 2 * 0.6,
            opacity: 0,
        })
        gsap.fromTo($chapter.querySelectorAll('[data-chapter-content]'), {
            opacity: 1,
        }, {
            opacity: 0,
            duration: this.chapterTransitionDuration / 2 * 0.3,
        })
    }
    initScrollToScreensContainer() {
        this.scrollTrigger = ScrollTrigger.create({
            trigger: '.acf-tts-hub__screens-container',
            start: "top 35%",
            end: "bottom 70%",
            onToggle: self => self.isActive && !this.scrollTween && this.scrollToScreensContainer(),
            // markers: true, // debug only
        })
    }
    scrollToScreensContainer() {
        this.scrollTween = gsap.to(window, {
            scrollTo: { y: this.scrollTrigger.start + innerHeight * 0.4 - 20, autoKill: false },
            duration: 1,
            onComplete: () => this.scrollTween = null,
            overwrite: true,
            // markers: true, // debug only
        })
    }
    initExpandables() {
        this.$el.querySelectorAll('.acf-tts-hub__screen').forEach(_$screen => {
            new Expandable(_$screen, {
                debug: false,
                on: {
                    open: ($region) => {
                        // this.scrollToScreensContainer()
                        this.$el.scrollIntoView(false)
                        
                        $region.removeAttribute('inert') 
                        
                        if (this.currentChapterId === $region.id) return
                        // else
                        this.revealChapter($region.id)
                        this.hideChapter(this.currentChapterId)
                        this.currentChapterId = $region.id
                    },
                    close: ($region) => {
                        $region.setAttribute('inert', 'inert') 
                    }    
                }
            })
        })
    }
    initAudio() {
        this.$audio = this.$el.querySelector('[data-hub-audio]')
        if (!this.$audio) return
        
        // else
        // this.console.log(this.$audio)
        this.$playBtn = this.$el.querySelector('[data-hub-audio-toggle]')
        
        
        this.$playBtn.addEventListener('click', () => {
            // Play or pause track depending on state
            if (this.$audio.paused === true) {
              this.$audio.play()
              this.$playBtn.dataset.playing = 'true';
            } else {
              this.$audio.pause()
              this.$playBtn.dataset.playing = "false";
            }
        }, {capture: false, passive: true, once: false} || false)
    }
    initIntro() {
        // split text
        this.intro = {
            $container: this.$el.querySelector('.acf-tts-hub__intro-container'),
            splitText: new SplitText('.acf-tts-hub__intro'),
            pixelsPerWord: 40,
        }
        
        // Header paralax & opacity
        gsap.to('.acf-tts-hub__header', {
            y: '-103lvh', 
            opacity: 0,
            scrollTrigger: {
                // trigger: 'header',
                scrub: true,
                start: 'top top',
                
                endTrigger: '.acf-tts-hub__intro',
                end: 'top bottom',
                
                // id: 'header',
                // markers: true, // debug only
                // end: 'bottom center',
                // pin: true,
            }
        })
        
        
        // intro words opacity
        gsap.to(this.intro.splitText.words, {
            opacity: 0.99,
            stagger: 0.1,
            ease: 'steps(1)',
            scrollTrigger: {
                trigger: this.intro.$container.querySelector('.acf-tts-hub__intro'),
                start: 'top 80%',
                // end: `+=${this.intro.splitText.words.length * this.intro.pixelsPerWord}`,
                
                end: 'bottom 80%',
                // pin: true,
                // id: 'intro',
                scrub: true,
                // markers: true, // debug only
            }
        })
        
        // intro words translateY
        /*gsap.to(this.intro.$container, {
          y: ScrollTrigger.maxScroll( this.intro.$container ) * -1,
          ease: 'power1.inOut',
          scrollTrigger: {
            trigger: this.intro.$container,
            start: 'top top',
            end: `+=${this.intro.splitText.words.length * this.intro.pixelsPerWord + vh(20)}`,
            pin: true,
            id: 'intro',
            scrub: true,
            markers: true, // debug only
          }
        })*/
        
        // `data-explore-me` translateY & scale
        /*gsap.fromTo('[data-explore-wrapper]', {
            y: '20%', 
            scale: 1.2,
            // translate(-3.90625%, 26.7981%); 
            // --map--scale: 2.1549999999999887;
        }, {
            y: '0%', 
            scale: 1,
            scrollTrigger: {
                trigger: '.acf-tts-hub',
                start: 'top top',
                endTrigger: '.acf-tts-hub__screens-container',
                end: 'top top',
                // pin: true,
                // id: 'y',
                scrub: true,
                // markers: true, // debug only
            }
        })*/
        
        // black gradient opacity
        /*gsap.fromTo('.acf-tts-hub__gradient', {
            opacity: 1,
        }, {
            opacity: 0,
            scrollTrigger: {
                trigger: '.acf-tts-hub__screens-container',
                start: 'top 35%',
                endTrigger: '.acf-tts-hub__screens-container',
                end: 'top top',
                // pin: true,
                // id: 'header',
                scrub: true,
                // markers: true, // debug only
            }
        })*/
    }
}

document.addEventListener('DOMContentLoaded', () => {
    [ ...document.querySelectorAll('.acf-tts-hub') ].forEach($block => {
        $block.expandygg = new TTSHub($block)
    })
}, {capture: false, passive: true, once: true} || false)
